module.exports = __webpack_public_path__ + "static/media/dollar-1-woodridge.dd6a5676.png";